module.exports = __webpack_public_path__ + "static/media/facebook.0b4b9a9d.svg";